import { AppConfig } from '/src/AppConfig';

const GOOGLE_ADS_CONTINUATION_PARAMS = [
  'google_ads_attempt_id',
  'google_ads_customers',
  'google_ads_customer_ids',
  'google_ads_connect_error',
];

const META_ADS_CONTINUATION_PARAMS = [
  'meta_ads_attempt_id',
  'meta_ads_attempt_token',
  'meta_ads_accounts',
  'meta_ads_connect_error',
];

export function redirectToGoogleAdsImport({ siteId, pathname, search }) {
  const redirectUrl = `${window.SHELL_APP_URL}${pathname}${search}`;
  const authUrl = new URL(`${AppConfig.authBaseURL()}/google-ads/import`);

  authUrl.searchParams.set('site_id', String(siteId));
  authUrl.searchParams.set('redirect_to', redirectUrl);

  window.location.assign(authUrl.toString());
}

export function redirectToExternalUrl(url) {
  window.location.assign(url);
}

export function redirectToMetaAdsConnectionSelection({ attemptId, attemptToken, accountId, pathname, search }) {
  const redirectUrl = `${window.SHELL_APP_URL}${pathname}${stripMetaAdsContinuationParams(search)}`;
  const completeUrl = new URL(`${AppConfig.coreApiBaseURL()}/ad-platform-connections/meta/complete`);

  completeUrl.searchParams.set('attempt_id', attemptId);
  completeUrl.searchParams.set('attempt_token', attemptToken);
  completeUrl.searchParams.set('account_id', accountId);
  completeUrl.searchParams.set('redirect_to', redirectUrl);

  window.location.assign(completeUrl.toString());
}

export function redirectToGoogleAdsImportSelection({ attemptId, customerId, pathname, search, loginCustomerId }) {
  const redirectUrl = `${window.SHELL_APP_URL}${pathname}${stripGoogleAdsContinuationParams(search)}`;
  const authUrl = new URL(`${AppConfig.authBaseURL()}/google-ads/import/complete`);

  authUrl.searchParams.set('attempt_id', attemptId);
  authUrl.searchParams.set('customer_id', customerId);
  authUrl.searchParams.set('redirect_to', redirectUrl);

  if (loginCustomerId) {
    authUrl.searchParams.set('login_customer_id', loginCustomerId);
  }

  window.location.assign(authUrl.toString());
}

export function stripGoogleAdsContinuationParams(search = '') {
  const params = new URLSearchParams(search);

  GOOGLE_ADS_CONTINUATION_PARAMS.forEach((key) => params.delete(key));

  const queryString = params.toString();

  return queryString ? `?${queryString}` : '';
}

export function stripMetaAdsContinuationParams(search = '') {
  const params = new URLSearchParams(search);

  META_ADS_CONTINUATION_PARAMS.forEach((key) => params.delete(key));

  const queryString = params.toString();

  return queryString ? `?${queryString}` : '';
}
